import { createSelector } from '../../../utilities';

const notificationTypes = {
  banner: 'BANNER',
  modal: 'MODAL'
};

const getUserNotifications = state => state.userNotifications.getUserNotifications.entity;

export const getBannerNotifications = createSelector(
  getUserNotifications,
  userNotifications =>
    userNotifications.filter(userNotification => userNotification.notificationType === notificationTypes.banner)
);

export const getUserNotificationBanner = createSelector(
  getBannerNotifications,
  bannerNotifications => {
    const [bannerNotification] = bannerNotifications;
    return bannerNotification;
  }
);

export const getModalNotifications = createSelector(
  getUserNotifications,
  userNotifications =>
    userNotifications.filter(userNotification => userNotification.notificationType === notificationTypes.modal)
);

export const getUserNotificationModal = createSelector(
  getModalNotifications,
  modalNotifications => {
    const [modalNotification] = modalNotifications;
    return modalNotification;
  }
);

const getPromotionsWithBanner = state => {
  if (state.header.header.enabledPromotions) {
    return state.header.header.enabledPromotions.filter(promotion => promotion.banner);
  }
  return [];
};

export const getShouldShowUserNotificationBanner = createSelector(
  [getUserNotificationBanner, getPromotionsWithBanner],
  (userNotificationBanner, promotionBanners) => {
    const doesUserNotificationBannerExist = Boolean(userNotificationBanner);
    const doesPromotionBannerExist = promotionBanners.length > 0;

    if (doesUserNotificationBannerExist && doesPromotionBannerExist) {
      const isUserNotificationError = userNotificationBanner.theme === 'ERROR';
      const isUserNotificationWarning = userNotificationBanner.theme === 'WARNING';
      return !!(isUserNotificationError || isUserNotificationWarning);
    }

    return doesUserNotificationBannerExist;
  }
);
